import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Grid,
  Loader,
  Typography,
} from '@statsbomb/kitbag-components';
import { useAtom, useAtomValue } from 'jotai';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { messageOffsetAlignmentVerificationAtom } from '../../atoms/messages';
import { videosRequiringAlignmentVerificationLoadingAtom } from '../../atoms/offsetAlignment';
import { AlignmentVerification } from '../../components/AlignmentVerification/AlignmentVerification';
import InputCompetition from '../../components/InputCompetition';
import { FOOTBALL_IDENTIFIER } from '../../components/Sport/Sport';
import useVideosRequiringOffsetAlignmentVerification from '../../hooks/offsetAlignment';

export function AlignmentVerificationCompetitionSeason() {
  const [message, setMessage] = useAtom(messageOffsetAlignmentVerificationAtom);

  const [selectedCompetitionId, setSelectedCompetitionId] = useState(null);
  const [selectedSeasonId, setSelectedSeasonId] = useState(null);

  const videosRequiringAlignmentVerificationLoading = useAtomValue(
    videosRequiringAlignmentVerificationLoadingAtom,
  );

  useEffect(() => {
    setMessage(null);
  }, []);

  const {
    clearVideosRequiringOffsetVerification,
    requestVideosRequiringAlignmentVerification,
  } = useVideosRequiringOffsetAlignmentVerification();

  const handleBack = () => {
    setMessage(null);
    setSelectedCompetitionId(null);
    setSelectedSeasonId(null);
    clearVideosRequiringOffsetVerification();
  };

  const handleCompetitionChange = (option) => {
    if (option) {
      const { competitionId, seasonId } = option.value;
      requestVideosRequiringAlignmentVerification(competitionId, seasonId);
      setSelectedCompetitionId(competitionId);
      setSelectedSeasonId(seasonId);
    }
  };

  const displayEvents =
    !videosRequiringAlignmentVerificationLoading &&
    selectedCompetitionId &&
    selectedSeasonId;

  return (
    <>
      {!displayEvents && (
        <Card data-testid="AlignmentVerification">
          <CardHeader>
            <Typography variant="headingRegular">
              <FormattedMessage
                defaultMessage="Historical Competitions"
                id="fe00b"
              />
            </Typography>
          </CardHeader>
          <CardBody>
            {message && <Alert type={message.type}>{message.text}</Alert>}
            {(!selectedCompetitionId || !selectedSeasonId) && (
              <Grid item>
                <InputCompetition
                  competitionId={selectedCompetitionId}
                  excludeUnlicensed
                  id="alignment-verification-comp-season-selection"
                  onChange={handleCompetitionChange}
                  seasonId={selectedSeasonId}
                  sport={FOOTBALL_IDENTIFIER}
                />
              </Grid>
            )}
            {videosRequiringAlignmentVerificationLoading && (
              <Loader colour="primary" />
            )}
          </CardBody>
        </Card>
      )}
      {displayEvents && <AlignmentVerification onBack={handleBack} />}
    </>
  );
}

AlignmentVerificationCompetitionSeason.propTypes = {};

export default { AlignmentVerificationCompetitionSeason };
